import { Component, OnInit } from '@angular/core';
import {NavController, NavParams, PopoverController} from '@ionic/angular';
import {FunkprotokollFall} from '../../../../clients/veranstaltungen';

@Component({
  selector: 'erinnerung-popover',
  templateUrl: './erinnerung-popover.component.html',
  styleUrls: ['./erinnerung-popover.component.scss'],
})
export class ErinnerungPopoverComponent implements OnInit {
  fall = <FunkprotokollFall>{};
  now = new Date();
  erinnerung = new Date();
  data = {};

  constructor(public popoverCtrl: PopoverController,
              public navCtrl: NavController,
              public navParams: NavParams) {
    this.fall = this.navParams.get('fall');
  }

  ngOnInit() {}

  erinnerungSetzen(minuten) {
    this.erinnerung.setMinutes(this.now.getMinutes() + minuten);
    this.data = {
      'erinnerung_in_minuten': minuten,
      'erinnerung_zeitpunkt_utc': this.erinnerung,
      'fall_id': this.fall.fall_id
    };
    this.popoverCtrl.dismiss(this.data);
  }

}
